<template>
  <div class="card">
    <!-- Если связанных стартов нет -->
    <div
      v-if="!currentLinkedStarts || !currentLinkedStarts.starts || currentLinkedStarts.starts.length === 0"
      class="card-body"
    >
      <p class="text-muted mb-4">
        Нет связанных стартов
      </p>
      <b-button
        variant="primary"
        @click="$bvModal.show('bv-modal-add-linked-starts')"
      >
        Добавить старт в серию
      </b-button>
      <b-button
        class="ml-2"
        variant="success"
        @click="$bvModal.show('bv-modal-create-linked-starts')"
      >
        Создать серию
      </b-button>
    </div>

    <!-- Если старты есть -->
    <div
      v-else
      class="card-body"
    >
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">
          Серия: {{ currentLinkedStarts.name }}
        </h5>
        <b-badge variant="info">
          {{ currentLinkedStarts.starts.length }} старта
        </b-badge>
      </div>

      <transition-group
        name="fade"
        tag="div"
        class="row"
      >
        <div
          v-for="start in currentLinkedStarts.starts"
          :key="start.id"
          class="col-md-4 mb-3"
        >
          <div class="card h-100 shadow-sm linked-item-card">
            <div class="card-body text-center">
              <h5 class="card-title mb-2">
                {{ start.name || 'Без названия' }}
              </h5>
              <p class="card-text text-muted mb-3">
                ID: {{ start.id }}
              </p>
              <b-button
                size="sm"
                variant="danger"
                @click="removeStart(start)"
              >
                <i class="fas fa-trash-alt" /> Удалить
              </b-button>
            </div>
          </div>
        </div>
      </transition-group>
    </div>

    <!-- Модалка -->
    <DistanceModalLinkedStarts
      :all-series="allSeries"
      :start-id="startId"
      @start-added="fetchLinkedStarts"
    />
    <DistanceModalCreateLinkedStarts
      :start-id="startId"
      @serie-created="fetchLinkedStarts"
    />
  </div>
</template>

<script>
import { BButton, BBadge } from 'bootstrap-vue'
import DistanceModalLinkedStarts from '@/views/starts/new-version/DistanceModalAddLinkedStarts.vue'
import DistanceModalCreateLinkedStarts from '../new-version/DistanceModalCreateLinkedStarts.vue'

export default {
  name: 'LinkedStarts',
  components: {
    BButton,
    BBadge,
    DistanceModalLinkedStarts,
    DistanceModalCreateLinkedStarts,
  },
  props: {
    allSeries: {
      type: Array,
      default: () => [],
    },
    startId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      currentLinkedStarts: null,
    }
  },
  watch: {
    allSeries: {
      handler() {
        this.findCurrentLinkedStarts()
      },
      immediate: true,
    },
  },
  methods: {
    findCurrentLinkedStarts() {
      this.currentLinkedStarts = this.allSeries.find(
        serie => serie.starts.some(s => s.id === this.startId),
      )
    },

    async fetchLinkedStarts() {
      try {
        const response = await this.$http.get('start/start-series/all-series')
        const allSeries = response.data
        this.$emit('update:allSeries', allSeries)
        this.currentLinkedStarts = allSeries.find(serie => serie.starts.some(s => s.id === this.startId))
      } catch (error) {
        console.error(error)
      }
    },

    async removeStart(start) {
      const serie = this.currentLinkedStarts
      if (!serie) return

      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Вы уверены, что хотите удалить старт «${start.name}» из серии "${serie.name}"?`,
        {
          title: 'Подтверждение удаления',
          okVariant: 'danger',
          okTitle: 'Удалить',
          cancelTitle: 'Отмена',
          footerClass: 'p-2',
          centered: true,
        },
      )

      if (!confirmed) return

      try {
        const payload = {
          startIds: serie.starts.filter(s => s.id !== start.id).map(s => s.id),
        }

        await this.$http.put('start/start-series/change-serie', payload, {
          params: { id: serie.id },
        })

        this.currentLinkedStarts = {
          ...serie,
          starts: serie.starts.filter(s => s.id !== start.id),
        }

        this.$bvToast.toast(`Старт «${start.name}» удалён из серии`, {
          title: 'Успешно',
          variant: 'success',
          solid: true,
        })
        await this.fetchLinkedStarts()
      } catch (error) {
        console.error('Ошибка при удалении старта из серии:', error)
        this.$bvToast.toast('Ошибка при удалении старта из серии', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '../scss/series-archives-shared.scss';
</style>
